import { render, staticRenderFns } from "./CouponOne.vue?vue&type=template&id=121fa93b&scoped=true"
import script from "./CouponOne.vue?vue&type=script&lang=js"
export * from "./CouponOne.vue?vue&type=script&lang=js"
import style0 from "./CouponOne.vue?vue&type=style&index=0&id=121fa93b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121fa93b",
  null
  
)

export default component.exports